<h1 mat-dialog-title>{{data?.title}}</h1>
<mat-dialog-content>
	<p [innerHTML]="data?.message | safeHtml"></p>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="5px">
	<button *ngIf="data?.showCancel" [color]="'accent'" mat-dialog-close mat-raised-button type="button">
		{{data?.cancelText ? data?.cancelText : 'Cancel'}}
	</button>
	<button [color]="'primary'" [mat-dialog-close]="true" mat-raised-button type="submit">
		{{data?.okText ? data?.okText : 'Ok'}}
	</button>
</mat-dialog-actions>
